export default "__VITE_ASSET__Cs1pD7Kh__"